import styled from 'styled-components/macro';
import { Container as Wrapper } from '../CommonStyles';

export const Container = styled(Wrapper)`
  padding: 17px 20px;
`;

export const BenchmarksTitle = styled.div`
  margin: 0 0 15px 0;
`;

export const AssetWeightContainer = styled.div`
  margin: 0 0 15px 0;
  background: #ffffff;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 15px;
`;

export const AssetWeightHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 18px;
  position: relative;
`;

export const AssetWeightedTitle = styled.div`
  font-size: 18px;
  bottom: 0;
`;

export const RequiredLabel = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 11px;
  position: absolute;
  margin-left: 132px;
  top: 9px;
`;

export const RequiredLabelAsterisk = styled.div`
  font-size: 11px;
  bottom: 2px;
  align-items: flex-end;
  color: red;
`;

export const AssetWeightedSelectContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 40%;

  & > * {
    margin-right: 8px;
  }
`;

export const TimeZoneInfo = styled.div`
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  color: #424242;
  display: flex;
  text-align: right;
  margin-right: 15px;
  align-self: end;
  height: 0;
  transform: translateY(10px);
`;
